import styled from 'styled-components';

import {fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';

export const InteractiveAnchor = styled.a.attrs({
  target: '_blank',
  rel: 'noopener noreferrer',
})`
  font-weight: ${fontWeights.semibold};
  color: ${(p) => p.theme.interactiveText};
  cursor: pointer;

  &:hover {
    color: ${(p) => p.theme.interactiveTextHover};
  }
`;
